import { render, staticRenderFns } from "./TariffCalculatorJumpMarkButton.vue?vue&type=template&id=9436d780&"
import script from "./TariffCalculatorJumpMarkButton.vue?vue&type=script&lang=ts&"
export * from "./TariffCalculatorJumpMarkButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports